import { isArray } from 'lodash'
import request, { requestList } from '../../../../utils/fetch'
const ENTRY = '/relations-getchilds'
const ENTRY_PARENT = '/relations-getparents'
const ENTRY_RELATION = '/relations'

export const getUserRelation = (
  userId,
  pageSize,
  page,
  sort,
  filtered,
  isParent = false
) => {
  if (!userId) return
  let tmp = [
    { id: 'parentType', value: 'user' },
    { id: 'childrenType', value: 'user' },
    {
      id: '$populate',
      value: [
        {
          foreignField: '_id',
          localField: isParent ? 'parentId' : 'childrenId',
          ref: 'users',
          path: 'childUserInfo',
          postPipe: [{ $unwind: '$childUserInfo' }]
        }
      ]
    }
  ]
  if (isParent) {
    tmp.push({ id: 'childrenId', value: userId })
  } else {
    tmp.push({ id: 'parentId', value: userId })
  }
  if (isArray(filtered)) {
    tmp = [
      ...tmp,
      ...filtered.map(item => ({
        ...item,
        id: `${isParent ? 'parentUserInfo' : 'childUserInfo'}.${item.id}`
      }))
    ]
  }
  return requestList(isParent ? ENTRY_PARENT : ENTRY, pageSize, page, sort, tmp)
}

export const addRelation = (parentId, childrenId) => {
  return request(ENTRY_RELATION, {
    method: 'POST',
    body: JSON.stringify({
      parentType: 'userId',
      childrenType: 'userId',
      parentId,
      childrenId,
      roles:['user']
    })
  })
}

export const deleteRelation = (parentId, childrenId) => {
  return request(
    `${ENTRY_RELATION}?parentId=${parentId}&childrenId=${childrenId}`,
    {
      method: 'DELETE'
    }
  )
}
